import { Typography } from '@mui/material';
import { Box } from '@mui/material';
import * as Preact from 'preact';
import * as BackAndClose from './M_BarsBackAndClose';
import * as Close from './M_BarsClose';
import * as TabGroup from './M_TabGroup';
/* -- Render 1 of 4 variants based on the props. With or without title. --*/
export var Component = function (p) {
    return (Preact.h(Box, { sx: { borderBottom: '1px solid rgba(0, 0, 0, 0.12)' } },
        p.onBackClick ? (Preact.h(BackAndClose.Component, { onBackArrowClick: p.onBackClick, onCloseClick: p.onCloseClick, disableClose: p.disableClose })) : (Preact.h(Close.Component, { onCloseClick: p.onCloseClick, disabled: p.disableClose })),
        p.title && (Preact.h(Typography, { variant: "h5", padding: "10px 16px" }, p.title)),
        p.tabGroup && (Preact.h(TabGroup.Component, { tabs: p.tabGroup.tabs, activeTabValue: p.tabGroup.activeTabValue, setTabValue: p.tabGroup.setTabValue, trackCompatibility: p.tabGroup.trackCompatibility }))));
};
Component.displayName = 'ProductDrawerNavigation';
